<div>
    <div>
        <app-collapse-button [isActive]="!isEditable" (click)='collapse()'></app-collapse-button>
        <app-reload-button-sm [isActive]="!isEditable && !isLoading" [isLoading]="isLoading" (click)="reload()"></app-reload-button-sm>
        <app-add-button-sm [isActive]="!isEditable && !isLoading" (click)='add()'></app-add-button-sm>
        <div (click)='collapse()' class='group-title' style='cursor: pointer;'>
            Objectives
            <div *ngIf="!isLoading" class='results'>({{objectives.length}})</div>
        </div>
    </div>
</div>

<div [ngClass]="{'hide':!display}">

    <app-loading [isLoading]="isLoading" *ngIf="isLoading"></app-loading>

    <div *ngIf="!isLoading">
        <div *ngIf='isAdd'>
            <div class='index'>
                <div class='row title' style='display:none;'></div>
                <div>
                    <app-course-objective></app-course-objective>
                </div>
            </div>
        </div>

        <div [ngClass]="{hide: isAdd}">
            <div class='text-center alert-text' *ngIf="errorMessage">
                {{errorMessage}}
            </div>

            <div *ngIf="!errorMessage">
                <div class='instructions' *ngIf='objectives.length === 0'>
                    No Objectives are associated with this Course.
                </div>

                <div class='instructions' *ngIf='objectives.length > 0'>
                    Listed below are the Objectives associated with this Course.
                </div>

                <div class='index'>
                    
                    <div class='row title'>
                        <div class='col-sm-1'>Order</div>
                        <div class='col-sm-11'>Objective</div>
                        <!-- <div class='col-sm-12'>Objective</div> -->
                    </div>
                    
                    <div class='row' *ngIf='objectives.length === 0'>
                        <div class='col-sm-12 text-center'>
                            There are no Objectives associated with this Course.
                        </div>
                    </div>
                    
                    <div *ngFor="let objective of objectives" class='row'>
                        <app-course-objective [objective]="objective"></app-course-objective>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>